/** A Shopify product gid the studio's procedures accept (Phase 91). Pure, no React. */
const GID_RE = /^gid:\/\/shopify\/Product\/\d{1,20}$/;

/** True for a Shopify product gid the server accepts. */
export function isStudioProductId(value: string | null | undefined): value is string {
  return typeof value === 'string' && GID_RE.test(value);
}
